export enum EnumStatusPix {
    Aceito,
    Cancelado,
    Neutro
}